// markdown-to-html.ts
import MarkdownIt from "markdown-it";
var markdownToHtml = (str) => MarkdownIt({ linkify: true, breaks: true }).render(str).replaceAll(/<a/g, "<x-link").replaceAll(/<\/a/g, "</x-link").replace(/\[\[([^\]]+)\]\]/g, "<x-highlight> [[$1]] </x-highlight>");
export {
  markdownToHtml
};
